import classNames from '../../utils/classNames'

interface GlowRingProps {
  /**
   * Extra classes for the ring itself — e.g. `[--glow-ring-width:2px]` to
   * thin it, or `[--glow-ring-size:220%]` for a host taller than it is wide.
   */
  className?: string
}

/**
 * The rotating beam that rings a card or button.
 *
 * Renders inside a `.game-card-glow` host, which supplies the positioning and
 * the corner radius the ring inherits. Purely decorative, so it is hidden from
 * assistive tech.
 *
 * This is a real element rather than the host's `::before` because the mask
 * that carves the ring has to hold still while the gradient underneath spins —
 * see the `.glow-ring` rules in index.css for the full reasoning.
 */
const GlowRing = ({ className = '' }: GlowRingProps) => (
  <span aria-hidden="true" className={classNames('glow-ring', className)} />
)

export default GlowRing
